import axios from "axios";

const checkVersion = "/api/v1/mq/fetchversion";
const initiateBoost = "/api/v1/mq/initiatemq";
const retriveTaskList = "/api/v1/mq/retrivemqlist";

class boostMQ {
  static async boostTaskList() {
    return new Promise((resolve, reject) => {
      axios
        .get(retriveTaskList)
        .then((res) => {
          const data = res.data;
          resolve(data);
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }

  static async initiateBoostMQ() {
    console.log(`run boost start`);
    return new Promise((resolve, reject) => {
      axios
        .post(initiateBoost)
        .then((res) => {
          const data = res.data;
          resolve(data);
        })
        .catch((err) => {
          console.log(err);
        });
    });

  }
}

export default boostMQ;
